export interface UserSettings {
  language: string
  timezone: string
  dateFormat: string
  itemsPerPage: number
  emailNotifications: boolean
  browserNotifications: boolean
  compactMode: boolean
  enableWarningsInMassbalance: boolean
}

export const KEY_USER_SETTINGS = 'userSettings';

export const DEFAULT_USER_SETTINGS: UserSettings = {
  language: 'en',
  timezone: 'Canada/Mountain',
  dateFormat: 'MM/dd/yyyy',
  itemsPerPage: 10,
  emailNotifications: true,
  browserNotifications: true,
  compactMode: false,
  enableWarningsInMassbalance: false
}

export function getUserSettings(): UserSettings {
  const savedSettings = localStorage.getItem(KEY_USER_SETTINGS)
  return { ...DEFAULT_USER_SETTINGS, ...JSON.parse(savedSettings || '{}') }
}

export function setUserSettings(settings: UserSettings) {
  localStorage.setItem('userSettings', JSON.stringify(settings))
}

export function generateRandomPassword(): string {
  // Define the character sets
  const uppercaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lowercaseLetters = 'abcdefghijklmnopqrstuvwxyz';
  const digits = '0123456789';
  const specialCharacters = '!@#$%^&*()_+-=[]{}|;:,.<>?';

  // Combine all character sets
  const allChars = uppercaseLetters + lowercaseLetters + digits + specialCharacters;

  // The required length of the password
  const passwordLength = 15;

  // Start with one character from each set to guarantee inclusion
  const password = [
    uppercaseLetters[Math.floor(Math.random() * uppercaseLetters.length)],
    lowercaseLetters[Math.floor(Math.random() * lowercaseLetters.length)],
    digits[Math.floor(Math.random() * digits.length)],
    specialCharacters[Math.floor(Math.random() * specialCharacters.length)],
  ];

  // Fill the rest of the password with random characters from all sets
  for (let i = password.length; i < passwordLength; i++) {
    const randomIndex = Math.floor(Math.random() * allChars.length);
    password.push(allChars[randomIndex]);
  }

  // Shuffle the array to ensure character positions are random
  // (Fisher-Yates shuffle algorithm)
  for (let i = password.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [password[i], password[j]] = [password[j], password[i]]; // Swap elements
  }

  // Join the array back into a string and return it
  return password.join('');
}
